import { AfterViewInit, Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit, AfterViewInit {
  @Input() icon: string;
  @Input() link: string;
  @Input() isSmallMenu = false;
  @Input() titleItem: string;
  @Input() isSubItem: boolean;
  @Input() isSmall: boolean; // subitem styles + bigger paddings
  @Input() ignoreActive: boolean;
  @Input() inverseMode = false;
  @Input() minify = false;
  @Input() externalUrl = false;

  @ContentChild('submenu') submenu: TemplateRef<void>;

  isSubmenuVisible = false;
  isSubmenuInactive = false;
  isActiveLink = false;

  constructor(private router: Router) { }

  ngOnInit() {
    this.isActiveLink = window.location.pathname.indexOf(this.link) >= 0;
    this.isSubmenuInactive = this.isActiveLink && !!this.submenu;

    this.router.events.subscribe(event => {
      // handle on navigation
      if (event instanceof NavigationEnd) {
        this.controlSubmenu(event.url);
        this.isActiveLink = event.url.indexOf(this.link) >= 0;
        this.isSubmenuInactive = this.isActiveLink && !!this.submenu;
      }
    });
  }

  ngAfterViewInit() {
    // initial loading
    this.controlSubmenu(this.router.url);
  }

  controlSubmenu(url: string) {
    this.isSubmenuVisible = this.submenu && url.indexOf(this.link) === 0;
  }

  get pseudoIcon(): string {
    const words = this.titleItem?.split(' ').map(word => word?.split(''));
    if (words?.length) {
      const first = words[0][0];
      const second = words[1] ? words[1][0] : '';
      return first + second;
    }
    return '';
  }

  onNavigationClick(event: Event) {
    if (this.submenu && !this.minify) {
      event.preventDefault();
      event.stopPropagation();
      this.isSubmenuVisible = !this.isSubmenuVisible;
      this.isSubmenuInactive = !this.isSubmenuInactive;
    } else {
      this.router.navigate([this.link]);
    }
  }
}
